import { notification } from 'antd';

export default function displaySuccess(title, duration, description) {
  notification.success({ message: title, duration, description });
}
